import { render, staticRenderFns } from "./AssessmentQuestionV1Properties.vue?vue&type=template&id=0e10e168&"
import script from "./AssessmentQuestionV1Properties.vue?vue&type=script&lang=js&"
export * from "./AssessmentQuestionV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports